import ReactOwlCarousel from 'react-owl-carousel';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function EorikSlider({
    items,
    random = false,
    imageFolder = 'slideshow',
    imageTyoe = 'orig',
    quality = 100,
    text,
}) {
    const apiUrl = useApiUrl();
    const shuffle = (array) => {
        const arr = array;
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const temp = arr[i];
            arr[i] = arr[j];
            arr[j] = temp;
        }
        return arr;
    };

    if (!items || !apiUrl) return null;

    const slides = random ? shuffle(items) : items;

    // return 'no slider';
    return (
        <>
            <style>
                {slides.length > 0
                    ? slides.map(
                          (item, key) =>
                              `.eorik-slider-item.slider-item-bg-${
                                  key + 1
                              }::after {background-image: url("${apiUrl}/img/exact/${imageFolder}/${imageTyoe}/1600/900/${quality}/${
                                  item.image
                              }");}`,
                      )
                    : `.eorik-slider-item.slider-item-bg-1::after {background-image: url("/assets/images/placeholders/placeholder_detailpagina_1.jpg");}`}
            </style>
            <ReactOwlCarousel
                className="eorik-slider owl-theme"
                loop
                margin={0}
                nav={false}
                mouseDrag={false}
                touchDrag={false}
                controls={false}
                items={1}
                dots={false}
                autoplay
                smartSpeed={1500}
                autoplayHoverPause
                animateOut="fadeOut"
                navText={[]}
            >
                {slides.length > 0 ? (
                    slides.map((item, key) => (
                        <div key={item.id} className={`eorik-slider-item slider-item-bg-${key + 1}`}>
                            {/* <img style={{position: 'absolute', width: '100vw', height: '100vh'}} src={`${apiUrl}/img/exact/${imageFolder}/${imageTyoe}/1920/1080/${quality}/${item.image}`} /> */}
                            <div className="d-table">
                                <div className="d-table-cell">
                                    <div className="container">
                                        <div className="eorik-slider-text overflow-hidden one eorik-slider-text-one">
                                            {text ? (
                                                <h1>{text}</h1>
                                            ) : (
                                                <>
                                                    <h1>
                                                        {item.titel} <br /> {item.subtitel}
                                                    </h1>
                                                    <p>{item.inhoud}</p>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="eorik-slider-item slider-item-bg-1">
                        <div className="d-table">
                            <div className="d-table-cell">
                                <div className="container">
                                    <div className="eorik-slider-text overflow-hidden one eorik-slider-text-one">
                                        {text && <h1>{text}</h1>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {}
            </ReactOwlCarousel>
        </>
    );
}
